<template>
	<div class="header-button-container" :class="showCheckout()">
		<div class="checkout-button-container" v-if="hasItems()">
			<router-link to="/checkout" class="button button--cart">
				<BaseIcon :className="['icon', 'cart']" icon="cartIcon" size="lg"/>
				<div class="item-count-background">
					<span class="item-count">
						{{ itemCount }}
					</span>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import { CART } from '@/stores/defs';

	export default {
		computed: { 
			...mapGetters({
				itemCount: CART.ITEM_COUNT,
			}),
		},
		methods: {
			...mapActions({
				setCart: CART.SET_ITEMS,
			}),
			hasItems() {
				if (this.itemCount > 0) {
					return true;
				}
				return false;
			},
			showCheckout() {
				const hasItems = this.hasItems();
				return (hasItems) ? 'show' : 'hide';
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.header-button-container {
		min-width: 23vw;
		transition: all 0.2s;
		&.show {
			opacity: 1;
		}
		&.hide {
			opacity: 0;
		}
	}
	.checkout-button-container {
		display: flex;
		margin-top: 0.5em;
		margin-bottom: 0;
		padding: 0;

		height: $mobileNavigationHeight;

		background-color: white;
		.button--cart {
			display: flex;
			justify-content: space-evenly;
			align-items: center;
			
			margin-right: 1vmin;
			border-radius: 3em;
			border-style: none;
			
			width: 100%;
			max-width: 23vw;
			width: 5.5rem;
			height: 48px;

			color: white;
			background-color: $checkoutButtonColor;

			font-weight: 600;

			&.router-link-active {
				div {
					background-color: transparent;
					color: $storeTextColor;
				}
			}

			.item-count-background {
				display: flex;
				justify-content: center;
				align-items: center;
				
				border-radius: 50%;
				
				width: 1.66rem;
				height: 1.66rem;
			}
		}
	}
	.header-button-container {
		display: flex;
		justify-content: flex-end;
		align-items: center;

		position: relative;
		top: 0;
		right: 0;

		height: $mobileNavigationHeight;
		width: 4.6em;
	}
	.button--cart {
		width: 4.6em;

		z-index: $zTopInteractionLayer;

		.item-count-background {
			position: relative;
			left: 0.55rem;

			background-color: white;
		}

		.item-count {
			color: $checkoutButtonColor;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/header/CheckoutButton.vue